import { useQuery } from "@apollo/client";
import { ButtonNav } from "Components/ButtonNav";
import { Section } from "Components/Section";
import { applicationByKeyQuery, ApplicationType } from "generated/graphql";
import React from "react";
import { useParams } from "react-router-dom";
import { serverConstants } from "Shared/Constants";
import { hasValue } from "Tools";
import { ApplicationNotFoundPage } from "./ApplicationNotFoundPage";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function QuoteSavedPage() {
  const { securityKey } = useParams<{ securityKey: string }>();
  const { data } = useQuery(applicationByKeyQuery, {
    variables: { securityKey },
  });
  if (!data) {
    return <>Loading...</>;
  }
  const app = data.applicationByKey;
  if (!hasValue(app)) {
    return <ApplicationNotFoundPage />;
  }
  const programPrefix = app.type === ApplicationType.DEFENSE ? "Defense " : "";
  return (
    <LcpAppPageWrapper
      isWide
      documentTitle={"Quote Saved"}
      programPrefix={programPrefix}
    >
      <Section
        title={`${programPrefix}${serverConstants.InsuranceName} Quote Saved`}
      >
        <div style={{ marginBottom: "1em" }}>
          Your quote for {programPrefix}
          {serverConstants.InsuranceName} has been saved and an email was sent
          to access the quote and purchase coverage.
        </div>
        <div>
          Thank you for quoting your insurance with{" "}
          {serverConstants.CompanyName}!
        </div>
        <ButtonNav>
          <a className="button is-primary" href={getQuotePath(app)}>
            View Quote
          </a>
        </ButtonNav>
        <nav style={{ textAlign: "center" }}>
          <a href={serverConstants.StaticSiteUrl}>
            Return to {serverConstants.StaticSiteHost}
          </a>
        </nav>
      </Section>
    </LcpAppPageWrapper>
  );
}

export function getQuotePath(app: {
  applicant: { state: string };
  securityKey: string;
}) {
  return `/${app.applicant.state}/#quote/${app.securityKey}`;
}
